import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Role } from '../../../models/enums';
import { AuthService } from '../../auth/auth.service';

/**
 * Guard qui redirige les utilisateurs externes vers leur premier module accessible.
 * Les utilisateurs internes passent directement (return true).
 */
export const defaultRouteExternalGuard = (): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.profile?.external) {
    return true;
  }

  // Logique de redirection pour les comptes externes
  const modules = authService.profile['roles_externals']
    .map((role: { role: { identifier: string } }) => role.role.identifier);

  let calendarEnabled = false;
  let projectEnabled = false;
  let hrEnabled = false;
  let inventoryEnabled = false;

  modules.forEach((module: string) => {
    switch (module) {
      case Role.CalendarsManager:
        calendarEnabled = true;
        break;
      case Role.Projects:
        projectEnabled = true;
        break;
      case Role.ComiteSalaryManager:
        hrEnabled = true;
        break;
      case Role.InventoryManager:
        inventoryEnabled = true;
        break;
    }
  });

  if (calendarEnabled) return router.parseUrl('/calendar');
  if (projectEnabled) return router.parseUrl('/project-management');
  if (hrEnabled) return router.parseUrl('/salaries');
  if (inventoryEnabled) return router.parseUrl('/materials');

  return router.parseUrl('/access-denied');
};
